// CustomSvgIcon.tsx
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';

const SvgIconBase = styled((props: SvgIconProps) => (
  <SvgIcon {...props}>
    {props.children}
  </SvgIcon>
))({
  /*'&:hover': {
    stroke: 'blue',
  },
  '&:active': {
    stroke: 'red',
  },*/
});

export default SvgIconBase;
